import React, { useEffect, useState } from "react";
import "./detailEval.css";
import iconRightArrow from "../../../assets/images/icon-right-arrow.png";
// import iconcalendar from "../../../assets/images/calendar.png";
import { useDispatch, useSelector } from "react-redux";
import { closeDetailEval } from "../../../redux/actions/design";
import iconcalendar from "../../../assets/images/icon-calend.svg";
import iconChat from "../../../assets/images/icon-chat.svg";
import iconInfo from "../../../assets/images/icon-info.svg";
import iconLike from "../../../assets/images/like-icon.png";
import iconDislike from "../../../assets/images/dislike-icon.png";
import {
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

import clsx from "clsx";
import { Avatar } from "@mui/material";

const DetailEval = (props) => {
  const [closeAnimation, setCloseAnimation] = useState(false);
  const { isOpenDetailEval } = useSelector((state) => state.design);
  const { dataeval } = useSelector((state) => state.evaluation);
  const [showAllValues, setShowAllValues] = useState(false);
  const [expandedAttributes, setExpandedAttributes] = useState({});

  const dispatch = useDispatch();
  let result = 0;
  // let finalSumResult
  let array = [];
  // let arrayGSum = []

  useEffect(() => {
    console.log("evallll=", dataeval);
  }, [dataeval]);
  useEffect(() => {
    console.log("props eval detail", props);
  }, []);
  function getSum(countCriteria, column) {
    if (array.length < countCriteria) {
      array = [...array, column];
      result = array.reduce((a, b) => a + b);
      if (array.length === countCriteria) {
        array = [];
        // arrayGSum = [...arrayGSum, result/countCriteria]
        // finalSumResult = getSumTotal(arrayGSum)
        return Math.round((result / countCriteria) * 100) / 100;
      }
    }
  }
  function getSumTotal(listScores) {
    return listScores.reduce((a, b) => a + b) / listScores.length;
  }
  function format(inputDate) {
    let date, month, year;

    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();

    date = date.toString().padStart(2, "0");

    month = month.toString().padStart(2, "0");

    return `${date}/${month}/${year}`;
  }

  return props.selected ? (
    <div
      key={props.key}
      className={clsx(
        { "detail-eval-container": isOpenDetailEval },
        { "detail-eval-containe-close": closeAnimation }
      )}
    >
      {!props.selected && (
        <div
          className="row left-side-detail-eval"
          onClick={() => {
            setCloseAnimation(true);
            setTimeout(() => {
              dispatch(closeDetailEval());
            }, 2000);
          }}
        ></div>
      )}
      <div
        className={
          !props.selected
            ? "row right-side-detail-eval"
            : "row side-detail-eval"
        }
      >
        <div className="container-topbar-of-callibrage">
          <div
            className="container-icon-arraw-left"
            onClick={() => {
              setCloseAnimation(true);
              setTimeout(() => {
                dispatch(closeDetailEval());
              }, 2000);
            }}
          >
            <img src={iconRightArrow} />
          </div>
          {!props.selected ? (
            <p className="detail-eval-title"> Détails évaluation </p>
          ) : (
            <p style={{ marginBottom: "0" }}> Détails évaluation </p>
          )}
        </div>
        <div
          className={
            !props.selected ? "row container-sub-bar" : "row container-sub-bar1"
          }
        >
          <div className="col-4 d-flex flex-column gap-15">
            <div className="container-score">
              <span style={{ font: "Gilroy-Semibold", color: "#B7B7B7" }}>
                {" "}
                Score Total :
              </span>
              <span className="detail-eval_score">
                {" "}
                {props.e?.eval?.note}/100{" "}
              </span>
            </div>
            <div className={!props.elmineDivision ? "container-info-eval-left-side": "container-info-eval-left-side-division"}>
              <div className="section-image">
                <Avatar
                  alt={props.e?.eval?.evaluateur?.username}
                  sx={{ bgcolor: "#5800E2", width: "30px", height: "30px" }}
                  variant="rounded"
                  className="borderedImg"
                >
                  {props.e?.eval?.evaluateur?.username.charAt(0).toUpperCase() +
                    props.e?.eval?.evaluateur?.username
                      .slice(
                        props.e?.eval?.evaluateur?.username.indexOf(" ") + 1
                      )
                      .charAt(0)
                      .toUpperCase()}
                </Avatar>
                <span style={{ fontFamily: "Gilroy-bold" }}>
                  {" "}
                  {props.e?.eval?.evaluateur?.username}{" "}
                </span>
              </div>
              <div className="section section-evaluator">
                <div className="container-evaluator">
                  <span className="section-names"> Evaluateur </span>
                  <Avatar
                    alt={props.e?.eval?.agent?.username}
                    sx={{ bgcolor: "#5800E2", width: "30px", height: "30px" }}
                    variant="rounded"
                    className="borderedImg"
                  >
                    {props.e?.eval?.agent?.username.charAt(0).toUpperCase() +
                      props.e?.eval?.agent?.username
                        .slice(props.e?.eval?.agent?.username.indexOf(" ") + 1)
                        .charAt(0)
                        .toUpperCase()}
                  </Avatar>{" "}
                  <div className="name-evaluator">
                    <span
                      style={{
                        fontFamily: "Gilroy-Semibold",
                        fontSize: "small",
                      }}
                    >
                      {" "}
                      {props.e?.eval?.agent?.username}{" "}
                    </span>
                    <span style={{ font: "Gilroy-Semibold", color: "#B7B7B7" }}>
                      {" "}
                      {props.e?.eval?.agent?.role?.name}{" "}
                    </span>
                  </div>
                </div>
              </div>
              <div className="section section-grille">
                <span className="section-names"> Grille </span>
                <div className="d-flex gap-15">
                  <span style={{ fontFamily: "Gilroy" }}>
                    {" "}
                    {props.e?.eval?.Grid?.name}{" "}
                  </span>
                </div>
              </div>
              <div className="section-date section-grille">
                <span className="section-names"> Date </span>
                <div className="d-flex gap-15">
                  <img src={iconcalendar} />
                  <span style={{ fontFamily: "Gilroy" }}>
                    {format(new Date(props.e?.eval?.dateInteraction))}{" "}
                  </span>
                </div>
              </div>
            </div>
            <div>Hello</div>
          </div>

          <div className="col-8" style={{ paddingLeft: 0 }}>
            <div className="container-info-eval-right-side">
              {props.e &&
                props.e.CriteriaGroup[0].map((e) => (
                  <div className="container-relationnel">
                    <div className="header-relationnel">
                      <span className="header-relationnel_text">
                        {" "}
                        {e.name}{" "}
                      </span>
                      <span>
                        {" "}
                        
                        {/* {e?.Criteria?.map((el, index) =>
                          getSum(
                            e.Criteria.length,
                            el.CriteriaValue[el.CriteriaValue.length - 1].score
                          )
                        )}{" "} */}
                      </span>
                    </div>
                    {e?.Criteria?.map((e1, index) => (
                      <div className="attribute-relationnel">
                        <span className="attribute-relationnel-title">
                          {" "}
                          {e1.name}{" "}
                        </span>
                        <div
                          className="d-flex flex-column align-items-center"
                          style={{ gap: 5 }}
                        >
                          <span
                            style={{
                              fontFamily: "Gilroy",
                              fontSize: "small",
                              color: `${
                                e1.CriteriaValue[e1.CriteriaValue.length - 1]
                                  ?.color
                              }`,
                            }}
                          >
                            {" "}
                            {
                              e1.CriteriaValue[e1.CriteriaValue.length - 1]
                                ?.name
                            }{" "}
                          </span>
                          <div
                            className="bar"
                            style={{
                              backgroundColor: `${
                                e1.CriteriaValue[e1.CriteriaValue.length - 1]
                                  ?.color
                              }`,
                            }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      className={clsx(
        { "detail-eval-container": isOpenDetailEval },
        { "detail-eval-containe-close": closeAnimation }
      )}
    >
      {!props.elmineDivision && (
        <div
          className="left-side-detail-eval"
          onClick={() => {
            setCloseAnimation(true);
            setTimeout(() => {
              dispatch(closeDetailEval());
            }, 2000);
          }}
        ></div>
      )}
      <div
        className={
          !props.elmineDivision ? "right-side-detail-eval" : "side-detail-eval"
        }
      >
        <div className="container-topbar-of-callibrage">
          <div
            className="container-icon-arraw-left"
            onClick={() => {
              setCloseAnimation(true);
              setTimeout(() => {
                dispatch(closeDetailEval());
              }, 2000);
            }}
          >
            <img src={iconRightArrow} />
          </div>
          {!props.elmineDivision ? (
            <p className="detail-eval-title"> Détails évaluation </p>
          ) : (
            <p className="detail-eval-title"> Détails evaluation </p>
          )}
        </div>
        <div
          className={
            !props.elmineDivision
              ? "row container-sub-bar"
              : "row container-sub-bar1"
          }
        >
          <div
            className="col-5 d-flex flex-column gap-15"
            style={{ height: "100%" }}
          >
            <div className="container-score">
              <span style={{ fontFamily: "Gilroy-Semibold", color: "#B7B7B7" }}>
                {" "}
                Score Total :
              </span>
              <span className="detail-eval_score">
                {" "}
                {props.selected
                  ? props.array?.eval?.note
                  : dataeval?.eval?.note}
                /100{" "}
              </span>
            </div>
            <div className={!props.elmineDivision ? "container-info-eval-left-side": "container-info-eval-left-side-division"}>
              <div className="section-image">
                <Avatar
                  alt={
                    dataeval?.eval?.agent?.firstName +
                    " " +
                    dataeval?.eval?.agent?.lastName
                  }
                  sx={{
                    bgcolor: "#5800E2",
                    width: "100px",
                    height: "100px",
                    fontSize: "2rem",
                  }}
                  className=""
                >
                  {dataeval?.eval?.agent?.firstName.charAt(0).toUpperCase() +
                    dataeval?.eval?.agent?.lastName.charAt(0).toUpperCase()}
                </Avatar>
                <span className="section-subnames">
                  {" "}
                  {dataeval?.eval?.agent?.firstName}{" "}
                  {dataeval?.eval?.agent?.lastName}{" "}
                </span>
              </div>
              <div className="section section-evaluator">
                <span className="section-names"> évaluateur </span>
                <div className="container-evaluator">
                  <Avatar
                    alt={
                      dataeval?.eval?.evaluateur?.firstName +
                      " " +
                      dataeval?.eval?.evaluateur?.lastName
                    }
                    sx={{ bgcolor: "#5800E2" }}
                    variant="rounded"
                    className="bordered-img-evaluator"
                  >
                    {dataeval?.eval?.evaluateur?.firstName
                      .charAt(0)
                      .toUpperCase() +
                      dataeval?.eval?.evaluateur?.lastName
                        .charAt(0)
                        .toUpperCase()}
                  </Avatar>
                  <div className="name-evaluator">
                    <span className="section-subnames_evaluateur">
                      {" "}
                      {dataeval?.eval?.evaluateur?.firstName}{" "}
                      {dataeval?.eval?.evaluateur?.lastName}{" "}
                    </span>
                    <span className="section-subnames_evaluateur-title">
                      {" "}
                      {dataeval?.eval?.evaluateur?.role?.name}{" "}
                    </span>
                  </div>
                </div>
              </div>
              <div className="section section-grille">
                <span className="section-names"> Date de création </span>
                <div className="d-flex gap-15">
                  <img src={iconcalendar} />
                  <span style={{ fontFamily: "Gilroy-SemiBold" }}>
                    {format(new Date(dataeval?.eval?.createdAt))}{" "}
                  </span>
                </div>
              </div>
              <div className="section section-grille">
                <span className="section-names"> Date d'intéraction </span>
                <div className="d-flex gap-15">
                  <img src={iconcalendar} />
                  <span style={{ fontFamily: "Gilroy-SemiBold" }}>
                    {format(new Date(dataeval?.eval?.dateInteraction))}{" "}
                  </span>
                </div>
              </div>
              <div className="section section-grille">
                <span className="section-names"> Grille </span>
                <div className="d-flex gap-15">
                  <span style={{ fontFamily: "Gilroy-SemiBold" }}>
                    {" "}
                    {dataeval?.eval?.Grid?.name}{" "}
                  </span>
                </div>
              </div>
             
              <div className={!props.elmineDivision ? "section section-attribut" : "section-attribut-division"}>
               {(dataeval?.Attributs && dataeval?.Attributs?.length != 0) && 
                 <> 
               <span className="section-names"> Attributs </span>
               
                   {dataeval?.Attributs?.sort((a, b) => {
                      return a?.Attribut?.name.localeCompare(b?.Attribut?.name, undefined, { sensitivity: 'accent' });
                      }).map((attribut) => {
                   //  const isExpanded = expandedAttributes[attribut?.Attribut.id];
                     return (
                       <div /*className="container-relationnel"*/>
                       <div className="attribut1" title={attribut?.Attribut.name}>
                       <span className="header-relationnel-attribut-text attr-title"
                      //  onClick={() =>
                      //  { setExpandedAttributes({
                      //     ...expandedAttributes,
                      //     [attribut?.Attribut?.id]: !isExpanded,
                      //   });
                      //   setShowAllValues(false)
                      // }}
                         > 
                       {attribut?.Attribut.name} </span>
                       
                       {attribut?.AttributValues?.map((values)=>{
                        return(
                          <span className="valeur-attribut">
                          <div className="attribute-relationnel-val-attrb attribut1" title={values?.name}>
                          <img src={iconRightArrow} style={{width : "4px"}} />  <span className="val-attr-title">{values?.name}</span>
                        </div>
                        </span>
                     
                        )
                       })}
                     </div>
                
                     </div>
                     )
                   })}
                 </>
                   
             } 
             </div> 

            </div>
          </div>

          <div className="col-7" style={{ paddingLeft: 0, height: "100%" }}>
            <div className="container-info-eval-right-side">
              {dataeval &&
                dataeval?.eval?.Grid &&
                dataeval?.eval.Grid?.CriteriaGroup?.map(
                  (e) =>
                    dataeval?.CriteriaGroup[e.name] &&
                    dataeval?.CriteriaGroup[e.name].length && (
                      <div className="container-relationnel">
                        <div className="header-relationnel">
                          <span className="header-relationnel_text">
                            {" "}
                            {e.name}
                          </span>
                          <span className="header-relationnel_res">
                            {" "}
                            {dataeval?.eval?.ScoreGroupCriteriaEval.filter((item)=> item.GroupCriteriaId == e.id).map((e)=> e.score)}
                            {/* {dataeval?.CriteriaGroup[e.name] &&
                              dataeval?.CriteriaGroup[e.name].length &&
                              dataeval?.CriteriaGroup[e.name]?.map((el) =>
                                getSum(
                                  dataeval?.CriteriaGroup[e.name].length,
                                  el.score
                                )
                              )} */}
                              {" "}
                          </span>
                        </div>
                        {dataeval?.CriteriaGroup[e.name] &&
                          dataeval?.CriteriaGroup[e.name].length &&
                          dataeval?.CriteriaGroup[e.name].map((e1, key) => (
                            <div className="attribute-relationnel">
                              <span> {e1.Criteria.name} </span>
                             
                              <div
                                className="d-flex flex-column align-items-center "
                                style={{ gap: 5 }}
                              >
                                <span
                                  style={{
                                    fontFamily: "Gilroy",
                                    fontSize: "small",
                                    color: `${e1.color}`,
                                  }}
                                >
                             
                                  {e1.value}
                                </span>
                                <div
                                  className="bar"
                                  style={{ backgroundColor: `${e1.color}` }}
                                ></div>
                              </div>
                              <div className="row" >
                              <div className="col margin-left-right">
                                <div>
                                  {e1.CriteriaOptions && e1.CriteriaOptions.filter((cr)=>cr.type==="BONUS").length > 0 ? (
                                    <div className="flex-space-between container-cercle-like">
                                    {e1.CriteriaOptions.filter((cr)=> cr.type ==="BONUS").length}
                                    </div>
                                  ) : null}
                                    <OverlayTrigger
                                    delay={{ show: 250, hide: 400 }}
                                    rootClose
                                    placement="bottom-end"
                                    overlay={<Tooltip>
                                      {e1.CriteriaOptions.filter((cr)=> cr.type ==="BONUS").map((cr)=> 
                                         <div
                                         className={clsx("container-bonus-malus-eval", {
                                           "container-bonus-malus-on":
                                           true,
                                         })}
                                         >
                                           {cr.name}
                                         </div>)}
                                       </Tooltip>}                                    >
                                       <img
                                        className="img-Info-position2"
                                        width={20}
                                        alt=""
                                        src={iconLike}
                                      />
                                    </OverlayTrigger>
                                  </div> 
                                  </div>
                                  <div className="col margin-left-right">
                                  <div>
                                  {e1.CriteriaOptions && e1.CriteriaOptions.filter((cr)=>cr.type==="MALUS").length > 0 ? (
                                    <div className="container-cercle-dislike">
                                    {e1.CriteriaOptions.filter((cr)=> cr.type ==="MALUS").length}
                                    </div>
                                  ) : null}
                                    <OverlayTrigger
                                    delay={{ show: 250, hide: 400 }}
                                    rootClose
                                    placement="bottom-end"
                                    overlay={<Tooltip>
                                     {e1.CriteriaOptions.filter((cr)=> cr.type ==="MALUS").map((cr)=> 
                                        <div
                                        className={clsx("container-bonus-malus-eval", {
                                          "container-bonus-malus-on":
                                          true,
                                        })}
                                        >
                                          {cr.name}
                                        </div>)}
                                      </Tooltip>}
                                    >
                                       <img
                                        className="img-Info-position2"
                                        width={20}
                                        alt=""
                                        src={iconDislike}
                                      />
                                    </OverlayTrigger>
                                  </div> 
                                  </div>
                            <div className="col margin-left-right">
                            <div>
                                <OverlayTrigger
                                 delay={{ show: 250, hide: 400 }}
                                 rootClose
                                 placement="bottom-end"
                                 overlay={<Tooltip><span style={{color : "black"}}>{e1.comment}</span></Tooltip>}
                                >
                                  <img
                                    className="img-chat-position1"
                                    src={iconChat}
                                  />
                                </OverlayTrigger>
                             </div>
                              <div>
                                <OverlayTrigger
                                 delay={{ show: 250, hide: 400 }}
                                 rootClose
                                 placement="bottom-end"
                                 overlay={<Tooltip><span style={{color : "black"}}>{e1.Criteria.coefficient}</span></Tooltip>}
                                >
                                  <img
                                    className="img-Info-position2"
                                    src={iconInfo}
                                  />
                                </OverlayTrigger>
                             </div>
                          
                             </div>
                             </div>
                            </div>
                          ))}
                      </div>
                    )
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailEval;
